module.exports = __webpack_public_path__ + "static/media/img10.175dc8dd.jpg";